export const user = `
    email
    phone_number
    sub
    username
    sub
    userStatus
`;
